import { last } from 'lodash';

import { Foreclosure, ForeclosureStatus } from '@willow/graphql-iso/src/app';

/**
 * Returns the most recent foreclosure that's still actively driving loan
 * behavior (active or paused). Status-first with endDate fallback for legacy
 * records that pre-date the new `status` field.
 */
export const getActiveForeclosure = (foreclosures?: Foreclosure[] | null): Foreclosure | undefined => {
  if (foreclosures == null) return undefined;
  return last(
    foreclosures.filter((fc) =>
      fc.status
        ? fc.status === ForeclosureStatus.Active || fc.status === ForeclosureStatus.OnHold
        : !fc.endDate && !fc.archivedAt,
    ),
  );
};
